module.exports = __webpack_public_path__ + "img/dynamic-3.d9d9fb94.png";